import React from "react";

const ProductInfo = ({ name, description }) => {
  return (
    <div className="product-info">
      <h1 className="product-title">{name}</h1>
      <p className="product-description">{description}</p>
    </div>
  );
};

export default ProductInfo;
